export default __webpack_public_path__ + "static/media/courses1.dd288b97.svg";